import { FormattedMessage, FormattedNumber } from 'react-intl'

import { Typography } from '@gto/ui/typography'

import { TicketsRules } from '@/pages/promotion/components/free-tournament-tickets/tickets-rules'
import { TicketsStatusTable } from '@/pages/promotion/components/free-tournament-tickets/tickets-status-table'
import { PromoDealsList } from '@/pages/promotion/components/promo-deals-list'
import { PromoOffersTips } from '@/pages/promotion/components/promo-offers-tips'

export const FreeTournamentTicketRoute = () => {
  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-6">
        <Typography variant="h4">
          <FormattedMessage
            id="promo.tournamentTickets.title"
            values={{
              prize: (
                <FormattedNumber
                  currency="USD"
                  minimumFractionDigits={0}
                  style="currency"
                  value={150}
                />
              ),
            }}
          />
        </Typography>
        <Typography variant="subtitle1">
          <FormattedMessage id="promo.tournamentTickets.description" />
        </Typography>
      </div>
      <div className="flex flex-col gap-6">
        <Typography variant="h5">
          <FormattedMessage id="promo.tournamentTickets.yourStatus" />
        </Typography>
        <TicketsStatusTable />
      </div>
      <PromoOffersTips items={tips} />
      <PromoDealsList />
      <TicketsRules />
    </div>
  )
}

const tips = [
  <FormattedMessage
    key="promo.tournamentTickets.tip.0"
    id="promo.tournamentTickets.tip.0"
  />,
  <FormattedMessage
    key="promo.tournamentTickets.tip.1"
    id="promo.tournamentTickets.tip.1"
  />,
  <FormattedMessage
    key="promo.tournamentTickets.tip.2"
    id="promo.tournamentTickets.tip.2"
  />,
]
